<template>
    <div class="container" v-if="showItems">
        <h2 class="title">Tendências {{currentYear}}</h2>
        
        <div id="tendencies-carousel">
            <div class="controls">
                <img class="controls__img" src="@/assets/img/shape.svg" alt="">
                <h3 class="controls__content">
                    Seleção de
                    produtos
                    para deixar
                    sua casa mais moderna</h3>
                <div class="swiper-button-prev" slot="button-prev"></div>
                <div class="swiper-button-next" slot="button-next"></div>
            </div>
            <swiper :options="swiperOption3" class="tend-carousel">
                <swiper-slide v-for="item in content" :key="item.id">
                    <router-link :to="{ name: 'produto', params: { id: item.friendly_url || item.id }}" class="slide-item">
                        <div class="slide-item__cart"><img src="@/assets/icons/tend-cart.svg" alt=""></div>
                        <div class="slide-item__img"><lazy-image :image="item.images[0]"/></div>
                        <div class="slide-item__info">
                            <h3 class="slide-item__name">{{item.name | productName}}</h3>
                            <span class="slide-item__id">Ref: {{item.ref}}</span>
                        </div>
                    </router-link>
                </swiper-slide>
            </swiper>
        </div>
    </div>
</template>

<script>
    import 'swiper/dist/css/swiper.css'
    import {swiper, swiperSlide} from 'vue-awesome-swiper'
    import LazyImage from "./LazyImage";
    
    export default {
        name: "TendenciesCarousel",
        props: {
            content: Array,
        },
        data() {
            return {
                slides: [],
                swiperOption3: {
                    breakpoints: {
                        // when window width is >= 320px
                        300: {
                            slidesPerView: 1,
                        },
                        767: {
                            slidesPerView: 1,
                        },
                        // when window width is >= 480px
                        768: {
                            slidesPerView: 2,
                            spaceBetween: 5
                        },
                        // when window width is >= 640px
                        1023: {
                            slidesPerView: 2,
                            spaceBetween: 15
                        }
                    },
                    // centeredSlides: true,
                    autoplay: {
                        delay: 3000,
                        disableOnInteraction: true
                    },
                    speed: 800,
                    spaceBetween: 15,
                    slidesPerView: 3,
                    slidesPerGroup: 1,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    }
                },
                showItems: false,
            }
        },
        filters: {
            productName(val) {
                return val.toLowerCase();
            }
        },
        computed: {
            currentYear() {
                const year = new Date();
                return year.getFullYear();
            }
        },
        components: {
            swiper,
            swiperSlide,
            LazyImage
        },
        watch: {
            content() {
                this.showItems = this.content.length;
            }
        }
    }
</script>

<style lang="scss" scoped>
    #tendencies-carousel {
        max-width: 1140px;
        margin: 30px auto 0 auto;
        display: flex;
        justify-content: space-between;
        overflow: hidden;
    }
    
    .title {
        margin-top: 60px;
        color: #2b2b2b;
        font-size: 2rem;
        font-family: HelveticaNeue, Arial, sans-serif;
        font-weight: 500;
    }
    
    .controls {
        flex-shrink: 0;
        width: 270px;
        height: 404px;
        background-image: url('../../assets/img/controls.jpg');
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
        margin-right: 30px;
        position: relative;
        
        &__img {
            margin: 50px auto 40px auto;
        }
        
        &__content {
            color: #fff;
            text-align: center;
            max-width: 160px;
            font-family: HelveticaNeueLight, Arial, sans-serif;
            font-weight: 300;
            font-size: 1.5rem;
            margin: 0 auto;
        }
    }
    
    .carousel-container, .tend-carousel {
        flex-grow: 1;
    }
    
    .slide-item {
        width: 270px;
        height: 404px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-end;
        padding: 20px;
        border: 1px solid transparent;
        position: relative;
        
        &:hover {
            border: 1px solid rgba(0, 0, 0, .1);
        }
        
        &__cart {
            transition: all .2s;
            opacity: 0;
            transform: translate3d(20px, 0, 0);
            position: absolute;
            right: 20px;
            top: 20px;
            width: 20px;
            height: 20px;
            cursor: pointer;
        }
        
        &__img {
            width: 228px;
            height: 228px;
            margin-top: 40px;
            margin-bottom: 20px;
            position: relative;
            overflow: hidden;
        }
        
        &__name {
            margin-bottom: 10px;
            font-family: "Open Sans";
            font-size: 1rem;
            font-weight: 600;
            color: #2b2b2b;
            
            &:first-letter {
                text-transform: uppercase;
            }
        }
        
        &__info {
            flex-grow: 1;
            width: 100%;
        }
        
        &__id {
            font-family: "Encode Sans";
            font-size: 0.75rem;
            color: #4d4d4d;
        }
    }

    ::v-deep .slide-item__img img {
        height: 100%;
    }
    
    .slide-item:hover .slide-item__cart {
        opacity: 1;
        transform: translate3d(0, 0, 0);
    }
    
    @media only screen and(max-width: 1200px) {
        .controls {
            margin-right: 15px;
        }
        
        .slide-item {
            padding: 10px;
            width: 220px;
        }
        
        .title {
            font-size: 2rem;
        }
    }
    
    @media only screen and(max-width: 768px) {
        .controls {
            width: 260px;
        }
    }
    
    @media only screen and(max-width: 767px) {
        #tendencies-carousel {
            width: 100%;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }
        
        .title {
            font-size: 1.5rem;
            text-align: center;
        }
        
        .controls {
            height: 200px;
            padding-bottom: 10px;
            margin-bottom: 30px;
            margin-right: 0;
            
            &__img {
                margin: 20px auto 20px auto;
            }
        }
        
        .controls__content {
            font-size: 1rem;
        }
        
        .slide-item__cart {
            opacity: 1;
            transform: translate3d(0, 0, 0);
        }

        .slide-item {
            width: 224px;
            height: 340px;


            &__img {
                margin-top: 70px;
                object-fit: cover;
            }
        }

        .tend-carousel {
            width: 220px;
        }
    }
</style>